import { useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import { FaTiktok, FaStoreAlt, FaInstagram } from "react-icons/fa";

const NavbarComponent = () => {
  const [expanded, setExpanded] = useState(false);
  window.onscroll = function () {
    scrollFunction();
  };

  function scrollFunction() {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      document.getElementById("navbar").style.backgroundColor =
        "rgba(255,255,255, 1)";
    } else {
      document.getElementById("navbar").style.backgroundColor =
        "rgba(255,255,255, 0.5)";
    }
  }

  const goToViolation = (id) => {
    const violation = document.getElementById(id);
    window.scrollTo({
      top: violation.offsetTop - 120,
      behavior: "smooth",
    });
    setExpanded(false);
  };

  return (
    <>
      {expanded && (
        <div className="close-canvas" onClick={() => setExpanded(false)}></div>
      )}
      <Navbar
        id="navbar"
        expand="lg"
        className="navbar-top"
        collapseOnSelect
        expanded={expanded}
      >
        <Container>
          <Navbar.Brand href="#" className="brand-name">
            <img
              src="https://main.mobile.doss.co.id/storage/uploads/2022/08/logo-papershoot-black.webp"
              alt="logo papershoot"
              className="main-logo"
            />
          </Navbar.Brand>

          <Navbar.Toggle onClick={() => setExpanded(!expanded)} />

          <Navbar.Offcanvas placement="start">
            <Offcanvas.Header closeButton>
              <Offcanvas.Title className="brand-name">
                <img
                  src="https://main.mobile.doss.co.id/storage/uploads/2022/08/logo-papershoot-black.webp"
                  alt="logo papershoot"
                  className="main-logo"
                />
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="justify-content-center align-items-center flex-grow-1">
                <Nav.Link onClick={() => goToViolation("home")}>Home</Nav.Link>

                <Nav.Link onClick={() => goToViolation("gallery")}>
                  Galeri
                </Nav.Link>
                <Nav.Link onClick={() => goToViolation("best-seller")}>
                  Shop
                </Nav.Link>
                <Nav.Link onClick={() => goToViolation("about")}>
                  Tentang Kami
                </Nav.Link>
                <Nav.Link onClick={() => goToViolation("contact")}>
                  Hubungi Kami
                </Nav.Link>
              </Nav>

              <div className="socmed-navbar">
                <div className="circle-icon me-2">
                  <FaInstagram
                    size={18}
                    color="#000000"
                    onClick={() =>
                      window.open(
                        "https://www.instagram.com/papershootstoreid/"
                      )
                    }
                  />
                </div>
                <div className="circle-icon me-2">
                  <FaTiktok
                    size={18}
                    color="#000000"
                    onClick={() =>
                      window.open("https://www.tiktok.com/@papershootstoreid")
                    }
                  />
                </div>
                <div className="circle-icon me-2">
                  <FaStoreAlt
                    size={18}
                    color="#000000"
                    onClick={() => window.open("https://doss.co.id/outlet")}
                  />
                </div>
              </div>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </>
  );
};

export default NavbarComponent;
